import { useQuery } from '@tanstack/react-query';
import { getSplitPaymentsGroup } from '../../services/payments';

function useGetSplitPaymentsGroup(
  splitPaymentsGroupId: string | null | undefined,
  {
    enabled = true,
  }: {
    enabled?: boolean;
  } = {},
) {
  return useQuery({
    queryKey: ['split-payments-group', splitPaymentsGroupId],
    enabled: !!splitPaymentsGroupId && enabled,
    placeholderData: undefined,
    queryFn: () =>
      getSplitPaymentsGroup({ splitPaymentsGroupId: splitPaymentsGroupId! }),
  });
}

export default useGetSplitPaymentsGroup;
